<script lang="ts" setup>
import styled from 'vue-styled-components';
import { i18n } from '@/i18n';
import { appendImportantStyle } from '@/utils/display/styleUtil';
import { CustomStyle } from '@/appLogic/interfaces/style';
// interface

// props
const props = defineProps<{
  labelName: string;
  customStyle?: CustomStyle;
}>();

// emits
const emits = defineEmits<{
  (e: 'click'): void;
}>();

// style variables
const Div = styled.div`
  ${{ ...appendImportantStyle(props?.customStyle?.['Div'] ?? {}) }}
`;
const Button = styled.button`
  ${{ ...appendImportantStyle(props?.customStyle?.['Button'] ?? {}) }}
`;

//変数
const t = i18n.t;

//computed

// イベント

//関数
const emitClick = () => {
  emits('click');
};
</script>

<template>
  <Div class="decision-button__wrapper mx-auto max-w-xs rounded">
    <Button class="decision-button mx-auto text-white font-bold py-2 px-4 rounded shadow-lg" @click="emitClick">
      {{ t(labelName) }}
    </Button>
  </Div>
</template>

<style lang="scss" scoped>
.decision-button {
  background-color: $semanticPrimary;
}
.decision-button:hover {
  opacity: 80%;
}
</style>
